import React from "react";
import Grid from "@mui/material/Grid";
import TextField from "@mui/material/TextField";

import FormControl from "@mui/material/FormControl";
import InputLabel from "@mui/material/InputLabel";
import Select from "@mui/material/Select";
import { MenuItem } from "@mui/material";

export default function General({
  client,
  countryCodes,
  handleInputChange,
  FORM_MODE,
}) {
  return (
    <Grid container spacing={2}>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          disabled
          name="ID"
          label="ID"
          value={client?.Id}
          onChange={(e) => handleInputChange("Id", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          autoFocus={true}
          name="Name"
          label="Namn"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.Name}
          onChange={(e) => handleInputChange("Name", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="OrgNo"
          label="Org.nr"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.OrgNo}
          onChange={(e) => handleInputChange("OrgNo", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Name2"
          label="Namn2"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.Name2}
          onChange={(e) => handleInputChange("Name2", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Address"
          label="Adress"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.Address}
          onChange={(e) => handleInputChange("Address", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="Address2"
          label="Adress2"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.Address2}
          onChange={(e) => handleInputChange("Address2", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="PostalCode"
          label="Postnr"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.PostalCode}
          onChange={(e) => handleInputChange("PostalCode", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          name="City"
          label="Ort"
          disabled={FORM_MODE === "LOCKED"}
          value={client?.City}
          onChange={(e) => handleInputChange("City", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <FormControl fullWidth sx={{ textAlign: "left" }} margin="dense">
          <InputLabel>Land</InputLabel>
          <Select
            value={client?.CountryCode}
            disabled={FORM_MODE === "LOCKED"}
            onChange={(e) => handleInputChange("CountryCode", e.target.value)}
            name="CountryCode"
            label="Landskod"
            size="small"
          >
            {countryCodes?.map((country) => (
              <MenuItem key={country.Value} value={country.Value}>
                {country.Name}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={6} md={4}>
        <TextField
          disabled
          name="CaseHandler"
          label="Handläggare"
          value={client?.CaseHandler}
          onChange={(e) => handleInputChange("CaseHandler", e.target.value)}
          size="small"
          fullWidth
          margin="dense"
        />
      </Grid>
    </Grid>
  );
}
